import {
  faBus,
  faCar,
  faChartBar,
  faMotorcycle,
  faQuestion,
  faTruck,
  faWalking,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from 'primereact/card'
import React from 'react'
import { VehicleCounts } from 'domain/vehicle-counts'

export interface VehicleTypeCountProps {
  vehicleCounts: VehicleCounts
}

const VehicleTypeCounter: React.FC<VehicleTypeCountProps> = ({
  vehicleCounts,
}) => {
  const totalVehicles =
    vehicleCounts.cars +
    vehicleCounts.bikes +
    vehicleCounts.trucks +
    vehicleCounts.buses +
    vehicleCounts.unknown +
    vehicleCounts.people

  const getPercentage = (totalVehicle: number) => {
    return totalVehicles > 0
      ? Number(((totalVehicle / (totalVehicles || 1)) * 100).toFixed(1))
      : 0
  }

  const vehicleTypes = [
    {
      type: 'Carros',
      count: vehicleCounts.cars,
      icon: faCar,
      color: '#3B82F6',
      bgColor: 'rgba(59, 130, 246, 0.3)',
      percentage: getPercentage(vehicleCounts.cars),
    },
    {
      type: 'Motos',
      count: vehicleCounts.bikes,
      icon: faMotorcycle,
      color: '#10B981',
      bgColor: 'rgba(16, 185, 129, 0.3)',
      percentage: getPercentage(vehicleCounts.bikes),
    },
    {
      type: 'Caminhões',
      count: vehicleCounts.trucks,
      icon: faTruck,
      color: '#f01657',
      bgColor: 'rgba(181, 11, 62, 0.3)',
      percentage: getPercentage(vehicleCounts.trucks),
    },
    {
      type: 'Ônibus',
      count: vehicleCounts.buses,
      icon: faBus,
      color: '#F59E0B',
      bgColor: 'rgba(245, 158, 11, 0.3)',
      percentage: getPercentage(vehicleCounts.buses),
    },
    {
      type: 'Pessoas',
      count: vehicleCounts.people,
      icon: faWalking,
      color: '#8B5CF6',
      bgColor: 'rgba(81, 20, 224, 0.3)',
      percentage: getPercentage(vehicleCounts.people),
    },
    {
      type: 'Desconhecido',
      count: vehicleCounts.unknown,
      icon: faQuestion,
      color: '#16e1f0',
      bgColor: 'rgba(6, 148, 158, 0.3)',
      percentage: getPercentage(vehicleCounts.unknown),
    },
  ]

  return (
    <>
      {' '}
      <div className='vehicle-types-section'>
        <div className='section-header mb-4'>
          <h3 className='section-title'>
            <FontAwesomeIcon
              icon={faChartBar}
              className='mr-2'
            />
            Detecções por Categoria
          </h3>
          <p className='section-subtitle'>
            Análise detalhada dos tipos de veículos capturados
          </p>
        </div>
      </div>
      <div className='grid'>
        {vehicleTypes.map((vehicle, index) => (
          <div
            key={`${vehicle.type} + ${vehicle.count}`}
            className='sm:col-4 xl:col-4 lg:col-3 col-6'
          >
            <Card className={`vehicle-card vehicle-card-${index + 1}`}>
              <div className='vehicle-card-inner'>
                <div className='vehicle-header'>
                  <div
                    className='vehicle-icon'
                    style={{
                      backgroundColor: vehicle.bgColor,
                      border: `2px solid ${vehicle.color}`,
                    }}
                  >
                    <FontAwesomeIcon
                      icon={vehicle.icon}
                      style={{ color: vehicle.color }}
                      size='lg'
                    />
                  </div>
                </div>

                <div className='vehicle-info'>
                  <h4 className='vehicle-type'>{vehicle.type}</h4>
                  <div className='vehicle-count'>
                    {vehicle.count.toLocaleString('pt-BR')}
                  </div>
                  <div className='vehicle-percentage'>
                    {vehicle.percentage}% do total
                  </div>
                </div>

                <div className='vehicle-progress'>
                  <div className='progress-bar'>
                    <div
                      className='progress-fill'
                      style={{
                        width: `${vehicle.percentage}%`,
                        backgroundColor: vehicle.color,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </>
  )
}

export default VehicleTypeCounter
